import React, { useState } from "react";
import { Link } from "react-router-dom";
import Batches from "./batches";
import SwapBatches from "./swapBatches";
import BatchSwap from "./batchSwap";

const BatchTabs = () => {

    const [activeTab, setActiveTab] = useState("Batches");
    const roleId = localStorage.getItem('RoleId');

    const tabData = [
        {
            icon: <i className="fas fa-truck" />,
            name: "Batches",
            content: <Batches />
        },
        ...((roleId == '1'||roleId == '5') ? [
            {
                icon: <i className="fas fa-warehouse" />,
                name: "Swap Batches",
                // content: <SwapBatches />
                content: <BatchSwap />
            },
        ] : [])
    ]
    return (
        <>
            <div className="content container" style={{ padding: "30px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to="#"
                                                        className={tab.name === activeTab ? "active" : ""}
                                                        onClick={() => setActiveTab(tab.name)}
                                                    >
                                                        {tab.icon} {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BatchTabs;